export default __webpack_public_path__ + "static/paper-texture-2f2fb0371ed9644dc50bfc1e20c939ac.jpg";